import { ReactNode } from "react";
import { Link } from "wouter";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "./button";
import { useSubscriptionTier } from "@/hooks/useSubscriptionTier";

interface TierPageProps {
  feature: string;
  pageTitle?: string;
  children: ReactNode;
}

export function TierPage({ feature, pageTitle = "this page", children }: TierPageProps) {
  const { hasFeature, isLoading } = useSubscriptionTier();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-pulse h-4 w-48 rounded bg-muted" />
      </div>
    );
  }

  if (hasFeature(feature)) {
    return <>{children}</>;
  }

  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="flex justify-center">
          <div className="rounded-full bg-red-100 p-4">
            <Lock className="h-8 w-8 text-red-600" />
          </div>
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-gray-900">Upgrade Required</h1>
          <p className="text-gray-600">
            Your current subscription tier does not include access to {pageTitle}.
          </p>
        </div>
        <div className="flex justify-center">
          <Link href="/">
            <Button variant="outline" className="gap-2">
              <ArrowLeft className="h-4 w-4" />
              Return to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
